export default {
    title: '登入'
}
